<form [formGroup]="configurationFormSFTP">
    <div class="form-row row">
        <div class="form-group col-md-4">

        </div>  
    </div>
    <div class="form-group col-md-4">
        <label for="useCustomFolderStructure"
          class="control-label">{{'i18n.domain.export-configuration.configurations.forms.lbsftp.form-fields.use-custom-folder'
          |
          translate}}</label>
        <app-yes-no-group-button id="useCustomFolderStructure" formControlName="useCustomFolderStructure">
        </app-yes-no-group-button>
      </div>
</form>
<div innerHTML="{{'i18n.domain.export-configuration.configurations.forms.lbsftp.ftp-information'| translate: {URLParam: apiServerUrl, PortParam: sftpPort} }}"></div>
